import { AddressBook } from "~/features/address-book/index.tsx";
import { Construction } from "~/shared/components/construction/construction.tsx";
import { LoadingSpinner } from "~/shared/components/loading-spinner/loading-spinner.tsx";
import { useFeatureFlagGate } from "~/shared/hooks/use-feature-flag-gate.ts";

export const AddressBookPage = () => {
	const { isReady, isEnabled } = useFeatureFlagGate("traxltlAddressBook");

	if (!isReady) {
		return <LoadingSpinner />;
	}

	return isEnabled ? <AddressBook /> : <Construction />;
};
